module.exports = __webpack_public_path__ + "img/SealOfRecognition.00a92895.png";